module.exports = __webpack_public_path__ + "img/close_side.9c5e0ef9.svg";